<template>
  <ExtendedDialog
    :show-dialog="show"
    :config="expiringTrialDialog"
    :title-msg="leftDaysOfTrialLicense"
    leftImageSource="assets/upselling/expiring.svg"
    @execute-action="execute($event)"
  >
    <div class="px-8 pb-4">
      <p>{{ $t('upselling.45DayTrialExpiring') }}</p>
      <p>{{ $t('upselling.lostFeatures') }}</p>
      <ProFeatures />
      <p>{{ $t('upselling.continueUsingFullFeatureSet') }}</p>
      <p>{{ $t('upselling.contactSales') }}</p>
    </div>
  </ExtendedDialog>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { mapState } from 'pinia';
import { licenseStore } from '@/store/pinia/LicenseStore';
import { ButtonCallbacks } from '@/components/types/Dialog';
import { captureComparePlans, continueWithTrial } from '@/util/posthog';
import { expiringTrialDialog } from '@/models/upselling/upsellingDialogConfig';

export default defineComponent({
  name: 'ExpiringTrialDialog',
  props: {
    showDialog: {
      type: Boolean,
      required: true
    }
  },
  emits: ['closeDialog'],
  data() {
    return {
      expiringTrialDialog
    };
  },

  computed: {
    ...mapState(licenseStore, ['leftDaysOfTrialLicense']),
    show: {
      get() {
        return this.showDialog;
      },
      set(value) {
        this.$emit('closeDialog', value);
      }
    }
  },
  methods: {
    async execute(callback: ButtonCallbacks) {
      if (callback === ButtonCallbacks.ACTION) {
        await this.$router.push('/plan-overview');
        captureComparePlans();
      } else {
        continueWithTrial(this.leftDaysOfTrialLicense);
      }
      this.show = false;
    }
  }
});
</script>
